import "styles/components/videos/videoPlayer.scss"

const injectEmbed = ({ el, videoId, autoPlay = false }) => {
  const autoplay = autoPlay ? 1 : 0

  el.classList.add("videoPlayer--busy")

  const iframeTag = document.createElement("iframe")
  iframeTag.id = `vimeoIframe-${videoId}`
  iframeTag.setAttribute("frameborder", 0)
  iframeTag.setAttribute("webkitallowfullscreen", 1)
  iframeTag.setAttribute("mozallowfullscreen", 1)
  iframeTag.setAttribute("allowfullscreen", 1)
  iframeTag.setAttribute(
    "allow",
    "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
  )
  iframeTag.onload = event => {
    el.classList.remove("videoPlayer--busy")
  }
  iframeTag.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=${autoplay}&mute=1`
  el.querySelector(".videoPlayer__embedHolder").appendChild(iframeTag)

  el.classList.add("videoPlayer--active")
}

const YoutubeEmbed = el => {
  const { videourl, autoload } = el.dataset
  // TODO: backend should return only video id not the full url
  let videoId = null
  const regex = /(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\/?\?(?:\S*?&?v\=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/gm
  let result
  while ((result = regex.exec(videourl)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (result.index === regex.lastIndex) {
      regex.lastIndex++
    }

    result.forEach(match => (videoId = match))
  }

  if (videoId) {
    if (autoload !== undefined) {
      injectEmbed({
        el,
        videoId,
        autoPlay: autoload
      })
    } else {
      $(el).one("click", ".videoPlayer__playVideoBtn", event => {
        event.preventDefault()
        injectEmbed({
          el,
          videoId,
          autoPlay: true
        })
      })
    }
  }
}

export { YoutubeEmbed }
